import {
    BellOutlined,
    BranchesOutlined,
    BugOutlined,
    FieldTimeOutlined,
    MailOutlined,
    MergeCellsOutlined,
    SearchOutlined,
    ShareAltOutlined,
    StopOutlined
} from "@ant-design/icons";
import { BsFillGearFill, BsJournalBookmarkFill, BsJournalPlus, BsJournalX } from "react-icons/bs";
import React from "react";
import { InputNumber } from "antd";
import RichTextEditor from "../Actions/utils/RichTextEditor";
import IconTriggerModal from "../Snippets/IconTriggerModal";
import { SelectForm } from "../Actions/utils/SelectForm";
import QueryBuilder from "../Actions/utils/QueryBuilder/index";
import CodeEditor from "../Actions/utils/CodeEditor";
import { getPropsDynamic } from "./triggers";
import { RowAction } from "../Actions/utils/RowAction";
import { SelectorUser } from "../Actions/utils/SelectUser";
import { LoopActionInput } from "../Actions/utils/LoopActionInput";
import { SelectAutomation } from "../Actions/utils/SelectAutomation";
import { SwitchFallbackEditor, SwitchRoutesEditor } from "../Actions/utils/SwitchRoutesEditor";
import { MergeSourcesEditor } from "../Actions/utils/MergeSourcesEditor";

const iconStyle = { fontSize: '25px' };

export const actions_types = [
    {
        defaultName: "Enviar E-mail",
        type: "send_mail",
        icon: <MailOutlined style={iconStyle} />,
        description: "Envie um e-mail para um ou mais destinatários especificados.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "sendTo",
                "title": "Enviar Para",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        "placeholder": "exemplo@dominio.com",
                        "addonAfter": <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                },
            },
            {
                "dataIndex": "subject",
                "title": "Assunto do E-mail",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        "placeholder": "Assunto",
                        "addonAfter": <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                },
            },
            {
                "dataIndex": "htmlContents",
                "title": "Conteúdo HTML",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<RichTextEditor fieldName={dataIndex} fieldLabel={title} />)
                },
            },

        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Criar Registro",
        type: "create_row",
        icon: <BsJournalPlus style={iconStyle} />,
        description: "Crie um novo registro em um formulário.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "fields",
                "title": "Campos",
                formItemRender: (dom) => {
                    const { dataIndex, title } = dom;
                    return <RowAction type={'create'} fieldName={dataIndex} fieldLabel={title} />;
                },
                formItemProps: {
                    label: false,
                },
            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Atualizar Registro",
        type: "update_row",
        icon: <BsJournalBookmarkFill style={iconStyle} />,
        description: "Atualize um registro existente em um formulário.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "fields",
                "title": "Campos",
                formItemRender: (dom) => {
                    const { dataIndex, title } = dom;
                    return <RowAction type={'update'} fieldName={dataIndex} fieldLabel={title} />;
                },
                formItemProps: {
                    label: false,
                },
            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Deletar Registro",
        type: "delete_row",
        icon: <BsJournalX style={iconStyle} />,
        description: "Exclua um registro em um formulário.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "formName",
                "title": "Formulário",
                formItemRender: () => <SelectForm />,
            },

            {
                "dataIndex": "executeRelatedTriggersOnThisAction",
                "title": "Acionar gatilhos atrelados a esse formulário quando essa ação for executada",
                "valueType": 'switch',
                "fieldProps": {
                    checkedChildren: "Sim",
                    unCheckedChildren: "Não",
                    defaultChecked: true
                },

            },
            {
                "dataIndex": "recordId",
                "title": "ID do Registro",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        placeholder: "",
                        addonAfter: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                }

            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Condição",
        type: "condition",
        icon: <ShareAltOutlined style={iconStyle} />,
        description: "Adicione uma condição para executar ações baseadas em critérios.",
        propsInput: [
            {
                "dataIndex": "referenceValue",
                "title": "Valor de referência",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        placeholder: "O valor a testar — ex.: {{ trigger.Resultado.0.value }} (use o ⚡)",
                        addonAfter: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                },
                "formItemProps": {
                    tooltip: "Um dos lados da comparação: normalmente o dado que você quer testar, vindo do gatilho ou do resultado de uma etapa anterior (botão ⚡).",
                },
            },
            {
                "dataIndex": "condition",
                "title": "Condição",
                "valueType": 'select',
                valueEnum: {
                    "equals": "Igual",
                    "not_equals": "Não é igual",
                    "greater_than": "Maior que",
                    "less_than": 'Menor que',
                },
                "formItemProps": {
                    tooltip: "A condição é um portão: se a comparação for verdadeira, a automação continua; se for falsa, ela para aqui (sem erro). Para seguir por caminhos diferentes, use o passo \"Desvio\".",
                },
            },
            {
                "dataIndex": "comparisonValue",
                "title": "Valor de comparação",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        placeholder: "Contra o que comparar — ex.: Implante retirado (fixo) ou {{ steps.2.value }}",
                        addonAfter: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                },
                "formItemProps": {
                    tooltip: "O outro lado da comparação: um valor fixo ou outra anotação. Os dois lados são comparados como texto depois de resolver os {{ }}.",
                },
            }
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Desvio",
        type: "switch",
        icon: <BranchesOutlined style={iconStyle} />,
        description: "Avalie um valor e desvie o fluxo para uma entre várias rotas nomeadas.",
        propsInput: [
            {
                "dataIndex": "comparisonValue",
                "title": "Valor avaliado",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        placeholder: "Ex.: {{ trigger.Situação.0.value }} ou {{ steps.2.value }}",
                        // A anotação entra como a raiz do campo: o desvio compara
                        // a lista inteira, cada item contra os caminhos.
                        addonAfter: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} wholeField />
                    }
                },
                "formItemProps": {
                    tooltip: "O valor que decide o caminho. Pode vir do gatilho ou do resultado de qualquer etapa anterior — use o botão ⚡ para escolher. Campo de múltipla escolha pode ser apontado inteiro ({{ trigger.Local }}): cada opção selecionada é comparada com os caminhos.",
                },
            },
            {
                "dataIndex": "mode",
                "title": "Modo de seleção",
                "valueType": 'select',
                "initialValue": 'first',
                valueEnum: {
                    "first": "Exclusivo — segue por um único caminho (padrão)",
                    "all": "Múltiplo — executa todos os caminhos cuja comparação casar",
                },
                "fieldProps": {
                    allowClear: false,
                },
                "formItemProps": {
                    tooltip: "A diferença só aparece se o valor casar com mais de uma linha (comparações sobrepostas). \"Exclusivo\": vence a primeira linha, de cima para baixo — bifurcação clássica. \"Múltiplo\": cada linha que casar executa seus passos — como várias automações reagindo ao mesmo evento. Com comparações exclusivas (= A, = B), os dois modos são idênticos.",
                },
            },
            {
                "dataIndex": "routes",
                "title": "Caminhos",
                formItemRender: (props) => {
                    return (<SwitchRoutesEditor />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "fallback",
                "title": "Se nenhum caminho casar",
                formItemRender: (props) => {
                    return (<SwitchFallbackEditor />)
                },
            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Junção",
        type: "merge",
        icon: <MergeCellsOutlined style={iconStyle} />,
        description: "Reúne alguns caminhos de um desvio para que sigam juntos, sem repetir as etapas comuns em cada um.",
        propsInput: [
            {
                "dataIndex": "label",
                "title": "Nome do caminho unificado",
                "fieldProps": {
                    "placeholder": "Ex.: Fluxo unificado",
                },
                "formItemProps": {
                    tooltip: "A junção cria um caminho novo, com este nome. Os passos que devem executar uma vez só para os caminhos unidos ficam nele — use o \"+\" da junção, no fluxo ao lado.",
                },
            },
            {
                "dataIndex": "sources",
                "title": "Caminhos unidos",
                formItemRender: () => <MergeSourcesEditor />,
            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Encerrar fluxo",
        type: "end_flow",
        icon: <StopOutlined style={{ ...iconStyle, color: '#cf1322' }} />,
        description: "Termina a automação neste ponto, com sucesso. Útil para um caminho do desvio acabar sem executar a continuação.",
        propsInput: [],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Executar script js",
        type: "script",
        icon: <BugOutlined style={iconStyle} />,
        description: "Execute um script JavaScript personalizado.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "script",
                "title": "Código do Script",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<CodeEditor fieldName={dataIndex} fieldLabel={title} />)
                },
            }],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Espera",
        type: "delay",
        icon: <FieldTimeOutlined style={iconStyle} />,
        description: "Adicione um atraso antes de executar a próxima ação.",
        propsInput: [
            {
                returnType: "numeric",
                dataIndex: "delay",
                title: "Atraso em milissegundos",
                valueType: "digit",
                formItemRender: (dom) => {
                    const { dataIndex, title } = dom;
                    return (
                        <InputNumber
                            style={{ width: '100%' }}
                            min={0}
                            max={60000}
                            placeholder=""
                            formatter={null}
                            keyboard={true}
                            addonAfter={<IconTriggerModal fieldName={dataIndex} fieldLabel={title} />}
                        />
                    );
                },
            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Consulta",
        type: "query",
        icon: <SearchOutlined style={iconStyle} />,
        description: "Faça uma consulta ao banco de dados.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                dataIndex: "query",
                title: "Filtros",
                formItemProps: {
                    label: false,
                },
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return <QueryBuilder fieldName={dataIndex} fieldLabel={title} />;
                },
            },

        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Iniciar uma automação",
        type: "start_automation",
        icon: <BsFillGearFill style={iconStyle} />,
        description: "Inicie uma automação específica.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "automation",
                "title": "Automação",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<SelectAutomation fieldName={dataIndex} fieldLabel={title} />)
                },
            },
            {
                "dataIndex": "payload",
                "title": "Dados iniciais do Gatilho",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<CodeEditor fieldName={dataIndex} fieldLabel={title} />)
                },
            },
        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    },
    {
        defaultName: "Enviar uma Notificação",
        type: "send_notificaiton",
        icon: <BellOutlined style={iconStyle} />,
        description: "Envia uma notificação para web para um usuário.",
        propsInput: [
            {

                "dataIndex": "loopData",
                "title": "Configuração de Repetição",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<LoopActionInput fieldName={dataIndex} fieldLabel={title} />)
                },
                formItemProps: {
                    label: false,
                },
            },
            {
                "dataIndex": "title",
                "title": "Título",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        placeholder: "",
                        addonAfter: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />,
                    }
                },
                "formItemProps": {
                    rules: [
                        {
                            required: true,
                        }
                    ]
                }
            },
            {
                "dataIndex": "type",
                "title": "Tipo de Notificação",
                "valueType": 'select',
                "valueEnum": {
                    "success": "Sucesso",
                    "error": "Erro",
                    "info": "Informativo",
                    "warning": 'Aviso',
                },
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        allowClear: false,
                        placeholder: "",
                        suffixIcon: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                },
                "formItemProps": {
                    rules: [
                        {
                            required: true,
                        }
                    ]
                }
            },
            {
                "dataIndex": "content",
                "title": "Conteúdo",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<RichTextEditor fieldName={dataIndex} fieldLabel={title} />)
                },
                "formItemProps": {
                    rules: [
                        {
                            required: true,
                        }
                    ]
                }
            },
            {
                "dataIndex": "action",
                "title": "Url de Ação",
                "fieldProps": (form, config) => {
                    const { dataIndex, title } = config;
                    return {
                        placeholder: "",
                        addonAfter: <IconTriggerModal fieldName={dataIndex} fieldLabel={title} />
                    }
                },
                formItemProps: {
                    "help": <p>Insira a URL completa para a ação desejada. URLs que começam com <b>'http://'</b> ou <b>'https://'</b> serão tratadas como links externos e redirecionarão para o site especificado.<br />
                        URLs que não incluem o protocolo (por exemplo,  <b>'/formularios/todos'</b>) serão interpretadas como rotas internas, acessando páginas de rota relativa dentro da aplicação.</p>
                }
            },

            {
                "dataIndex": "recipient",
                "title": "Enviar Para",
                formItemRender: (props) => {
                    const { title, dataIndex } = props
                    return (<SelectorUser fieldName={dataIndex} fieldLabel={title} />)
                },
                "formItemProps": {
                    rules: [
                        {
                            required: true,
                        }
                    ]
                }
            }


        ],
        propsOutput: [
            {
                "dataIndex": "success",
                "title": "Sucesso",
            }
        ]
    }
];

export const actionAcceptLoop = [
    "send_mail",
    "create_row",
    "update_row",
    "delete_row",
    "script",
    "query",
    "send_notificaiton"
]

export const getPropsFromAction = async (action) => {
    // Sem etapa (posição que já não existe), o resto da função devolve só as
    // anotações padrão — este primeiro acesso não pode quebrar antes disso.
    const inLoop = action &&
        actionAcceptLoop.includes(action.type) &&
        action.config &&
        action.config.loopData &&
        action.config.loopData.active;

    let defaultProps = [
        {
            field: "success",
            type: "Boleano",
            fieldtype: "Boleano",
        }
    ];

    // Só um passo dentro de um caminho do desvio pode deixar de executar. Para
    // ele o executor publica `skipped: true` no lugar do resultado, e é isso
    // que uma etapa posterior consulta para saber se aquele caminho foi
    // percorrido — sem isso, "não executou" não se distingue de "executou e
    // deu vazio".
    if (action && action.branch) {
        defaultProps = [
            ...defaultProps,
            {
                field: "skipped",
                type: "Boleano",
                fieldtype: "Boleano",
            }
        ];
    }

    if (inLoop) {
        defaultProps = [
            ...defaultProps,
            {
                field: "loop.item",
                type: "Objeto",
                fieldtype: "Objeto",
                propFromLoop: true
            },
            {
                field: "loop.index",
                type: "Texto",
                fieldtype: "Texto",
                propFromLoop: true
            },
            {
                field: "loop.isLast",
                type: "Boleano",
                fieldtype: "Boleano",
                propFromLoop: true
            }
        ]
    }

    if (action) {
        switch (action.type) {
            case "create_row":
            case "update_row":
            case "delete_row":
                const propsRow = [
                    {
                        field: "id",
                        type: "Object",
                        fieldtype: "objetc",
                    }
                ]
                let dynamicallyPropsRow = [];
                if (action.config && action.config.formName && action.config.formName.id) {
                    dynamicallyPropsRow = await getPropsDynamic(action.config.formName.id)
                }
                return [
                    ...defaultProps,
                    ...propsRow,
                    ...dynamicallyPropsRow
                ];
            case "script":
                const propsScript = [
                    {
                        field: "value",
                        type: "Retorno do processamento do script",
                        fieldtype: "Retorno do processamento do script",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsScript
                ]
            case "send_mail":
                const propsEmail = [
                    {
                        field: "response",
                        type: "Objeto",
                        fieldtype: "Objeto",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsEmail,
                ];
            case "condition":
                const propsCondition = [
                    {
                        field: "condition",
                        type: "Boleano",
                        fieldtype: "Boleano",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsCondition,
                ];
            case "switch":
                const propsSwitch = [
                    {
                        field: "value",
                        type: "Nome da rota selecionada (ou lista, no modo \"todas\")",
                        fieldtype: "Texto",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsSwitch,
                ];
            case "merge":
                const propsMerge = [
                    {
                        field: "value",
                        type: "Caminho que chegou até a junção (ou lista, no modo \"todos\")",
                        fieldtype: "Texto",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsMerge,
                ];
            case "delay":
                const propsDelay = [
                    {
                        field: "delay",
                        type: "Numérico",
                        fieldtype: "Numérico",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsDelay,
                ];
            case "query":
                const propsQuery = [
                    {
                        field: "rows",
                        type: "Objeto",
                        fieldtype: "Objeto",
                    }
                ]
                return [
                    ...defaultProps,
                    ...propsQuery,
                ];
            case "start_automation":
            default:
                return defaultProps
        }
    }
    return defaultProps
}
